<template>

    <div class="layout-landing">
        <v-the-header></v-the-header>
        <div class="layout-landing-body">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
        <v-the-footer></v-the-footer>
    </div>

</template>

<style scoped lang="scss">

    .layout-landing {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        .layout-landing-body {
            flex-grow: 1;
            padding-top: 60px;
            position: relative;
        }
    }

</style>

<script>

import TheFooter from '@cmp/TheFooter';
import TheHeader from '@cmp/TheHeader';

export default {

    components: {
        'v-the-footer': TheFooter,
        'v-the-header': TheHeader,
    },

}

</script>
